var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMaps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F1522F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2732 14.4675C19.5008 14.3434 19.7425 14.5343 19.7425 14.7935V32.0889C19.7425 32.3121 19.5914 32.5024 19.3894 32.5974C19.3496 32.6161 19.3109 32.6357 19.2732 32.6563L16.2925 34.3559C14.2123 35.5482 12.5 34.5589 12.5 32.1489V19.8075C12.5 19.0084 13.0708 18.019 13.7811 17.6131L19.2732 14.4675ZM28.3432 17.7164C28.5136 17.8008 28.6213 17.9744 28.6213 18.1645V35.1448C28.6213 35.5133 28.2363 35.7552 27.9043 35.5952L22.2453 32.8688C22.0723 32.7854 21.9623 32.6103 21.9623 32.4183V15.3619C21.9623 14.991 22.3518 14.7493 22.6842 14.9138L28.3432 17.7164ZM37.5001 30.5127V18.1712C37.5001 15.7613 35.7878 14.7719 33.7076 15.9642L31.0932 17.4565C30.9373 17.5455 30.8411 17.7113 30.8411 17.8908V34.9264C30.8411 35.3106 31.2564 35.5512 31.5897 35.3602L36.2191 32.707C36.9294 32.3011 37.5001 31.3118 37.5001 30.5127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaps);
export default __webpack_public_path__ + "static/media/icon_maps.77c1de14db3edfe5a15afab947976d53.svg";
export { ForwardRef as ReactComponent };